import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom"; // updated
import { newEnrollmentAction } from "../../pages/enrolment/enrolmentAction";
import { updatePreEnrolmentAction } from "../../pages/pre-enrolment/preEnrolmentAction";
import { CustomModalBox } from "../modal/CustomModalBox";
import "./updatePreEnrolmentForm.css";

const initialInstallmentState = {
  status: "paid",
  amount: "",
  paidDate: "",
  dueDate: "",
  transactionId: "",
  types: "",
  paymentMethod: "",
};

let fullFee = 6500;

export const UpdatePreEnrolment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // updated
  const { _id } = useParams();
  const { user } = useSelector((state) => state.user);
  const { preEnrolments } = useSelector((state) => state.preEnrol);

  const preEnrolment = preEnrolments.find((pre) => pre._id === _id);

  const [installments, setInstallments] = useState(initialInstallmentState);
  const [userProfile, setUserProfile] = useState(preEnrolment || {});

  useEffect(() => {
    setUserProfile(preEnrolment || {});
  }, [preEnrolment]);

  const { __v, eoiId, createdAt, updatedAt, ...otherDetails } = userProfile;

  const handleOnChange = (e) => {
    const { name, value, checked } = e.target;

    setUserProfile({
      ...otherDetails,
      [name]: name === "sendPaymentReceivedEmail" ? checked : value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const { amount, paidDate, dueDate, transactionId, types, paymentMethod } =
      installments;

    const { fName, lName, mobile, email } = otherDetails;

    const params = new URLSearchParams();
    params.set("branch", user?.branch);
    const par = params.toString();

    try {
      // If only personal info changed
      if (
        preEnrolment.fName !== fName ||
        preEnrolment.lName !== lName ||
        preEnrolment.mobile !== mobile ||
        preEnrolment.email !== email
      ) {
        if (
          window.confirm("Are you sure you want to update this pre-enrolment?")
        ) {
          dispatch(
            updatePreEnrolmentAction(_id, { fName, lName, mobile, email })
          );
        }
        return;
      }

      // If payment info is also added
      if (
        amount &&
        paidDate &&
        dueDate &&
        transactionId &&
        types &&
        paymentMethod
      ) {
        if (
          window.confirm(
            "Are you sure you want to update this pre-enrolment information and send to enrolments list?"
          )
        ) {
          if (types === "installment") {
            dispatch(
              newEnrollmentAction({
                ...otherDetails,
                ...installments,
                params: par,
              })
            );
          } else if (types === "full") {
            dispatch(
              newEnrollmentAction({
                ...otherDetails,
                params: par,
                payment: {
                  paidFull: true,
                  status: "paid",
                  paidDate,
                  dueDate,
                  totalPaid: amount,
                  method: paymentMethod,
                },
              })
            );
          }

          navigate("/enrol"); // navigate after submission
        }
        return;
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }

    return alert("No information has been changed");
  };

  return (
    <CustomModalBox title="UPDATE PRE-ENROLMENT">
      <form className="enrol-form" onSubmit={handleOnSubmit}>
        <div className="form-row">
          <Row>
            <Col md="6">
              <label htmlFor="fName">First Name</label>
              <input
                type="text"
                id="fName"
                name="fName"
                placeholder="First Name"
                className="form-control mt-2"
                value={userProfile.fName || ""}
                onChange={handleOnChange}
              />
            </Col>
            <Col md="6">
              <label htmlFor="lName">Last Name</label>
              <input
                type="text"
                id="lName"
                name="lName"
                placeholder="Last Name"
                className="form-control mt-2"
                value={userProfile.lName || ""}
                onChange={handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <label htmlFor="mobile">Mobile</label>
              <input
                type="number"
                id="mobile"
                name="mobile"
                placeholder="Mobile"
                className="form-control mt-2"
                value={userProfile.mobile || ""}
                onChange={handleOnChange}
              />
            </Col>
            <Col md="6">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                className="form-control mt-2"
                value={userProfile.email || ""}
                onChange={handleOnChange}
              />
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <label htmlFor="dueDate">Due Date</label>
              <input
                type="date"
                id="dueDate"
                name="dueDate"
                className="form-control mt-2"
                value={installments.dueDate}
                onChange={(e) =>
                  setInstallments({ ...installments, dueDate: e.target.value })
                }
              />
            </Col>
            <Col md="6">
              <label htmlFor="paidDate">Paid Date</label>
              <input
                type="date"
                id="paidDate"
                name="paidDate"
                className="form-control mt-2"
                value={installments.paidDate}
                onChange={(e) =>
                  setInstallments({ ...installments, paidDate: e.target.value })
                }
              />
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <label htmlFor="transactionId">Transaction ID</label>
              <input
                type="text"
                id="transactionId"
                name="transactionId"
                placeholder="Transaction ID"
                className="form-control mt-2"
                value={installments.transactionId}
                onChange={(e) =>
                  setInstallments({
                    ...installments,
                    transactionId: e.target.value,
                  })
                }
              />
            </Col>
            <Col md="6">
              <label htmlFor="amount">Add Amount</label>
              <input
                type="number"
                id="amount"
                name="amount"
                placeholder="Amount $$"
                className="form-control mt-2"
                value={installments.amount}
                onChange={(e) =>
                  setInstallments({
                    ...installments,
                    amount: Number(e.target.value),
                  })
                }
              />
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <label htmlFor="paymentType">Payment Type</label>
              <select
                id="paymentType"
                className="form-control mt-2"
                value={installments.types}
                onChange={(e) =>
                  setInstallments({ ...installments, types: e.target.value })
                }
              >
                <option value="">----- Select Payment Type -----</option>
                <option
                  value="installment"
                  disabled={installments.amount === fullFee}
                >
                  Installment
                </option>
                <option value="full" disabled={installments.amount !== fullFee}>
                  Full Payment
                </option>
              </select>
            </Col>

            <Col md="6">
              <label htmlFor="paymentMethod">Payment Method</label>
              <select
                id="paymentMethod"
                className="form-control mt-2"
                value={installments.paymentMethod}
                onChange={(e) =>
                  setInstallments({
                    ...installments,
                    paymentMethod: e.target.value,
                  })
                }
              >
                <option value="">----- Select Payment Method -----</option>
                <option value="transfer">Transfer</option>
                <option value="card">Card</option>
                <option value="cash">Cash</option>
              </select>
            </Col>

            <Col md="6" className="d-flex align-items-center gap-2 mt-2">
              <input
                type="checkbox"
                name="sendPaymentReceivedEmail"
                checked={userProfile.sendPaymentReceivedEmail || false}
                onChange={handleOnChange}
              />
              <label htmlFor="sendPaymentReceivedEmail">Send Email</label>
            </Col>
          </Row>
        </div>

        <button type="submit" className="enrol-btn mt-3">
          UPDATE
        </button>
      </form>
    </CustomModalBox>
  );
};
